import React from 'react';
import { XCircleIcon } from 'lucide-react';
export function FailedSolutions() {
  const failures = ['Los multivitamínicos de supermercado no tienen la pureza ni la dosis necesaria para mover tu aguja hormonal.', 'Las dietas de "bajar de peso" eliminan las grasas saturadas saludables que son la materia prima de tu testosterona.', 'Intentar entrenar como un joven de 20 años solo te genera lesiones y eleva el cortisol, lo que destruye aún más tus hormonas.', 'Los consejos genéricos de salud ignoran que tu mayor enemigo hoy es el estrés oxidativo y la falta de sueño profundo.'];
  return <section className="bg-navy-900 py-20 px-4 sm:px-6 lg:px-8" data-id="element-1">
      <div className="max-w-4xl mx-auto" data-id="element-2">
        <h2 className="font-playfair text-3xl sm:text-4xl font-bold text-center text-white mb-12" data-id="element-3">
          Por qué lo que has intentado{' '}
          <span className="text-red-400" data-id="element-4">no funcionó</span>
        </h2>
        <div className="grid gap-6" data-id="element-5">
          {failures.map((text, index) => <div key={index} className="flex items-start bg-navy-800 p-6 rounded-xl border border-navy-700 shadow-lg" data-id="element-6">
              <XCircleIcon className="w-8 h-8 text-red-400 shrink-0 mt-1 mr-4" data-id="element-7" />
              <p className="text-lg text-[#e0e0e0] leading-relaxed" data-id="element-8">{text}</p>
            </div>)}
        </div>
      </div>
    </section>;
}